import React from 'react'
import PropTypes from 'prop-types'
import styles from './TooltipTitle.scss'

/**
 * A styled tooltip title.
 */
const TooltipTitle = ({ children, ...domProps }) => (
  <div {...domProps} className={styles.tooltipTitle}>
    <span className={styles.title}>{children}</span>
  </div>
)

TooltipTitle.propTypes = {
  /**
   * The tooltip title.
   */
  children: PropTypes.node,
}

export default TooltipTitle
